'use client';

import { ChatContactPanelProps } from '../../types/chat';
import { ContactList } from '../molecules/ContactList';

export function ChatContactPanel({ contacts, onContactSelect }: ChatContactPanelProps) {
  const totalUnreadCount = contacts.reduce((sum, contact) => sum + contact.unreadCount, 0);

  return (
    <div className="flex flex-col h-full bg-white">
      {/* Header */}
      <div className="p-4 border-b border-[#DEE2E7]">
        <div className="flex items-center justify-between">
          <h1 className="text-lg font-semibold text-[#323B49]">EZ-Talk</h1>
          {totalUnreadCount > 0 && (
            <div className="bg-[#EF4444] text-white text-xs rounded-full min-w-[20px] h-5 flex items-center justify-center px-1">
              {totalUnreadCount > 99 ? '99+' : totalUnreadCount}
            </div>
          )}
        </div>
        <p className="text-sm text-[#6D717D] mt-1">
          {contacts.length}개의 채팅
        </p>
      </div>

      {/* Contact list */}
      <ContactList contacts={contacts} onContactSelect={onContactSelect} />
    </div>
  );
}